import React from 'react';
import { Card } from '../../../shared/components';
import type { DocumentImages as DocumentImagesType } from '../useDocumentImages';

const Img: React.FC<{ label: string; src: string; small?: boolean }> = ({ label, src, small }) => (
  <div className="flex flex-col items-center gap-2">
    <p className="text-[11px] font-semibold uppercase tracking-wide text-gray-400">{label}</p>
    <img
      src={src}
      alt={label}
      className="rounded-xl object-contain shadow-md ring-1 ring-gray-200"
      style={{ width: small ? '120px' : '100%', maxWidth: small ? '120px' : '480px' }}
    />
  </div>
);

interface DocumentImagesProps {
  images: DocumentImagesType;
}

/** Sección de imágenes capturadas (anverso, reverso, rostro, firma). */
export const DocumentImages: React.FC<DocumentImagesProps> = ({ images }) => {
  const { face, front, back, signature } = images;
  if (!face && !front && !back && !signature) return null;

  return (
    <Card title="Imágenes capturadas">
      <div className="space-y-5">
        {(front || back) && (
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
            {front && <Img label="Anverso" src={front} />}
            {back  && <Img label="Reverso" src={back} />}
          </div>
        )}
        {(face || signature) && (
          <div className="flex flex-wrap gap-6">
            {face      && <Img label="Rostro" src={face}      small />}
            {signature && <Img label="Firma"  src={signature} small />}
          </div>
        )}
      </div>
    </Card>
  );
};
